import { Injectable } from '@angular/core';
import { ApiConfig } from './config.api';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MaintenanceApi {
  constructor(private httpClient:HttpClient) {
  }

  getStatus() {
    return this.httpClient.get(ApiConfig.baseURL + 'api/maintenance');
  }
}
